<template>
  <div>
    <v-dialog v-model="dialog" @keydown.esc="dialog = false" max-width="400px">
      <v-card>
        <v-form ref="form" lazy-validation>
          <v-card-title>
            <span class="headline"
              >{{ $t("update") }} {{ $t("main_file") }}
            </span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="mainfileData.license_plate"
                    :label="$t('licensePlate')"
                    disabled
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-combobox
                    v-model="mainfileData.channel_uuid"
                    :label="$t('channel')"
                    disabled
                  ></v-combobox>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="mainfileData.list_type"
                    :items="listTypeItems"
                    :label="$t('list_type')"
                  ></v-select>
                </v-col>
              </v-row>

              <v-divider class="mb-1" />

              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="mainfileData.area"
                    :label="$t('area')"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="mainfileData.chinese_name"
                    :label="$t('chinese') + ' ' + $t('name')"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="mainfileData.english_name"
                    :label="$t('english') + ' ' + $t('name')"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="mainfileData.company"
                    :label="$t('company')"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="mainfileData.department"
                    :label="$t('department')"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="mainfileData.employee_number"
                    :label="this.$t('employee') + ' ' + this.$t('number')"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-divider class="mb-1" />

              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="mainfileData.ID_number"
                    :label="$t('ID_number')"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="mainfileData.phone"
                    :label="$t('phone')"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="mainfileData.address"
                    :label="$t('address')"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-divider class="mb-1" />

              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="mainfileData.parking_space_number"
                    :label="this.$t('parking_space') + ' ' + this.$t('number')"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6">
                  <v-select
                    v-model="mainfileData.parking_type"
                    :items="parkingTypeItems"
                    :label="$t('parking') + ' ' + $t('type')"
                  ></v-select>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="mainfileData.time_period"
                    :label="$t('time') + ' ' + $t('period')"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="mainfileData.extra_field_1"
                    :label="$t('extra_field') + '1'"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="mainfileData.extra_field_2"
                    :label="$t('extra_field') + '2'"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="mainfileData.extra_field_3"
                    :label="$t('extra_field') + '3'"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>

            <small>*{{ $t("indicates-required-field") }}</small>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" text @click="dialog = false">
              {{ $t("close") }}
            </v-btn>

            <v-btn color="primary" text @click="updateMainfile">
              {{ $t("update") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { updateMainfile } from "@/endpoint/mainfile";

export default {
  name: "MainfileAddDialog",
  props: ["item"],
  data() {
    return {
      dialog: false,
      mainfileData: {
        license_plate: null,
        channel_uuid: null,
        list_type: "normal",
        area: null,
        chinese_name: null,
        english_name: null,
        company: null,
        department: null,
        employee_number: null,
        parking_space_number: null,
        ID_number: null,
        phone: null,
        address: null,
        time_period: null,
        parking_type: null,
        extra_field_1: null,
        extra_field_2: null,
        extra_field_3: null,
      },
      listTypeItems: ["whitelist", "blacklist", "VIP"],
      parkingTypeItems: ["normal", "month", "fixed"],
    };
  },
  watch: {
    item() {
      if (this.item != null) {
        this.mainfileData = JSON.parse(JSON.stringify(this.item));
      }
    },
  },
  methods: {
    updateMainfile() {
      if (!this.$refs.form.validate()) {
        return;
      }

      const data = {};

      if (this.mainfileData.license_plate != null) {
        data.license_plate = this.mainfileData.license_plate.toUpperCase();
      }

      if (this.mainfileData.channel_uuid != null) {
        data.channel_uuid = this.mainfileData.channel_uuid;
      }

      if (this.mainfileData.list_type != null) {
        data.list_type = this.mainfileData.list_type;
      }

      if (this.mainfileData.area != null) {
        data.area = this.mainfileData.area;
      }

      if (this.mainfileData.chinese_name != null) {
        data.chinese_name = this.mainfileData.chinese_name;
      }

      if (this.mainfileData.english_name != null) {
        data.english_name = this.mainfileData.english_name;
      }

      if (this.mainfileData.company != null) {
        data.company = this.mainfileData.company;
      }

      if (this.mainfileData.department != null) {
        data.department = this.mainfileData.department;
      }

      if (this.mainfileData.employee_number != null) {
        data.employee_number = this.mainfileData.employee_number;
      }

      if (this.mainfileData.parking_space_number != null) {
        data.parking_space_number = this.mainfileData.parking_space_number;
      }

      if (this.mainfileData.ID_number != null) {
        data.ID_number = this.mainfileData.ID_number;
      }

      if (this.mainfileData.phone != null) {
        data.phone = this.mainfileData.phone;
      }

      if (this.mainfileData.address != null) {
        data.address = this.mainfileData.address;
      }

      if (this.mainfileData.time_period != null) {
        data.time_period = this.mainfileData.time_period;
      }

      if (this.mainfileData.parking_type != null) {
        data.parking_type = this.mainfileData.parking_type;
      }

      if (this.mainfileData.extra_field_1 != null) {
        data.extra_field_1 = this.mainfileData.extra_field_1;
      }

      if (this.mainfileData.extra_field_2 != null) {
        data.extra_field_2 = this.mainfileData.extra_field_2;
      }

      if (this.mainfileData.extra_field_3 != null) {
        data.extra_field_3 = this.mainfileData.extra_field_3;
      }

      updateMainfile(data).then(() => {
        this.dialog = false;
        this.$router.go();
      });
    },
  },
};
</script>